"use client";
import React, { useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import { LOCATION_MILES_ARRAY } from "../filter-contant-values/filter-constants";
import Regions from "@packages/shared-components/sr-page/SrFilter/regions";
import Accordion from "@packages/shared-components/common-utilities/accordion/accordion";
import { sanitizeInput } from "@packages/lib/utlils/sanitization";
import { generatePathName } from "@packages/lib/utlils/filters/result-filters";
import { getUserLocation } from "@packages/lib/utlils/filters/result-filters";
import { useFilterContext } from "@packages/lib/utlils/use-context/filter-context";
import CityCheckBoxComponent from "../components/city-checkbox-comp";
import emitter from "@packages/lib/eventEmitter/eventEmitter";
const LocationFilterAccordian = ({
  jsondata,
  keyName,
  formUrl,
  appendSearchParams,
  locationRef,
  urlAndSession,
}: any) => {
  const {
    slug,
    filterState,
    selectedLocation,
    prepopulateFilter,
    setPrepopulateFilter,
    locationState,
    setLocationState,
  } = useFilterContext();
  const getPostcode = async () => {
    const getCode = await getUserLocation();
    setLocationState((prev: any) => ({
      ...prev,
      postCodeValue: getCode?.postcode || "",
    }));
  };
  const FirstLevelRegion = jsondata?.regionList
    ?.map((region: any) => {
      if (region?.parentRegionId == 1) return region;
    })
    ?.filter(Boolean);
  const toggleLocationMiles = (milesDisplayName: string, distance: string) => {
    setLocationState((prev: any) => ({
      ...prev,
      isdropDownOpen: !prev?.isdropDownOpen,
      selectedMile: distance,
      mileDisplayName: milesDisplayName,
    }));
  };
  const postcodeSubmit = () => {
    const ukPostCodeRegx = /^([A-Z]{1,2}[0-9][0-9A-Z]?)\s?([0-9][A-Z]{2})$/i;
    const isValidPostcode = ukPostCodeRegx.test(locationState?.postCodeValue);
    if (locationState?.postCodeValue && isValidPostcode) {
      setLocationState((prev: any) => ({ ...prev, locationMilesError: false }));
      if (urlAndSession?.postcode !== locationState?.postCodeValue) {
        appendSearchParams("postcode", locationState?.postCodeValue);
      } else {
        appendSearchParams("distance", locationState?.selectedMile);
      }
    } else {
      setLocationState((prev: any) => ({ ...prev, locationMilesError: true }));
    }
  };
  const postCodeChange = (value: string) => {
    const specialCharRegex = /[^a-zA-Z0-9\s]/;
    if (!specialCharRegex.test(value) && value?.length <= 8) {
      setLocationState((prev: any) => ({
        ...prev,
        postCodeValue: value?.toUpperCase(),
      }));
    }
  };

  useEffect(() => {
    const handleRemovePostcode = () => {
      setLocationState((prev: any) => ({
        ...prev,
        mileDisplayName: "Any",
        postCodeValue: "",
        selectedMile: "any",
      }));
    };
    emitter.on("removePostcode", handleRemovePostcode);
    return () => {
      emitter.off("removePostcode", handleRemovePostcode);
    };
  }, []);

  return (
    <>
      {(jsondata?.cityList?.length > 0 || jsondata?.regionList?.length > 0) && (
        <>
          {slug?.split("/")[2] !== "csearch" &&
            !filterState?.filterOrder?.university &&
            !prepopulateFilter?.university && (
              <Accordion
                title="Location"
                id="#location"
                defaultOpenStatus={
                  filterState?.selectedFilter === "all" ||
                  filterState?.selectedFilter === "location"
                }
              >
                <div className="flex flex-col gap-[24px]">
                  <div className="flex flex-col gap-[8px] pt-[24px]">
                    <div className="font-semibold">Distance from home</div>
                    <div className="flex flex-col gap-[16px]">
                      <div className="bg-white rounded-[24px] w-full p-[16px] border border-grey-200 hover:border-primary-500 shadow-custom-1 md:rounded-[32px] md:pl-[24px] md:p-[4px] md:w-[530px]">
                        <div className="flex flex-col gap-[24px] small md:flex-row md:items-center md:gap-[10px]">
                          <div className="relative shrink-0">
                            <button
                              onClick={() => {
                                toggleLocationMiles(
                                  locationState?.mileDisplayName,
                                  locationState?.selectedMile,
                                );
                              }}
                              className="relative shrink-0 w-full flex items-center justify-between gap-[4px] pr-0 text-black md:pr-[16  px]"
                              type="button"
                            >
                              Range: {locationState?.mileDisplayName}
                              <Image
                                src="/static/assets/icons/arrow_down_black.svg"
                                width="20"
                                height="20"
                                alt="Search icon"
                              />
                            </button>
                            {locationState?.isdropDownOpen && (
                              <div
                                ref={locationRef}
                                className="bg-white z-[1] shadow-custom-3 rounded-[4px] absolute left-[-16px] top-[33px] w-[calc(100%+32px)] md:w-[calc(100%+16px)]"
                              >
                                <ul>
                                  {LOCATION_MILES_ARRAY?.map(
                                    (mileItem: any, index: any) => (
                                      <li
                                        key={index + 1}
                                        onClick={() => {
                                          toggleLocationMiles(
                                            mileItem?.miles,
                                            mileItem?.distance,
                                          );
                                        }}
                                        className="block small px-[16px] py-[12px] hover:bg-blue-50 hover:underline cursor-pointer"
                                      >
                                        {mileItem?.miles}
                                      </li>
                                    ),
                                  )}
                                </ul>
                              </div>
                            )}
                          </div>
                          <div className="w-full grow border-y-[1px] border-grey-200 md:border-l md:border-y-0">
                            <input
                              type="text"
                              className="w-full focus:outline-none text-black placeholder:text-gray-500 px-[0] py-[24px] md:px-[16px] md:py-[0px]"
                              aria-label="submenu"
                              placeholder="Enter Postcode"
                              value={locationState?.postCodeValue || ""}
                              onChange={(event) => {
                                postCodeChange(event.target.value);
                              }}
                            />
                          </div>
                          <button
                            onClick={postcodeSubmit}
                            type="submit"
                            className="btn btn-primary flex items-center justify-center gap-[6px] px-[24px] py-[7px] md:min-w-[114px] md:w-[130px]"
                          >
                            <Image
                              src="/static/assets/icons/search_icon.svg"
                              width="18"
                              height="18"
                              alt="Search icon"
                            />
                            Search
                          </button>
                        </div>
                      </div>
                      {locationState?.locationMilesError && (
                        <p className="small text-negative-default">
                          Please enter valid postcode
                        </p>
                      )}
                    </div>
                    <div className="flex items-center gap-[4px]">
                      <svg
                        width="16"
                        height="18"
                        viewBox="0 0 16 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.3137 12.8137C11.5923 13.5351 10.1389 14.9886 9.04085 16.0866C8.2598 16.8676 6.99496 16.8675 6.21391 16.0865C5.13566 15.0082 3.70908 13.5817 2.94113 12.8137C0.352958 10.2255 0.352958 6.02929 2.94113 3.44113C5.52929 0.852958 9.72554 0.852958 12.3137 3.44113C14.9019 6.02929 14.9019 10.2255 12.3137 12.8137Z"
                          stroke="#4664DC"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M10.1127 8.12742C10.1127 9.5 9 10.6127 7.62742 10.6127C6.25484 10.6127 5.14214 9.5 5.14214 8.12742C5.14214 6.75483 6.25484 5.64214 7.62742 5.64214C9 5.64214 10.1127 6.75483 10.1127 8.12742Z"
                          stroke="#4664DC"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <div
                        onClick={getPostcode}
                        className="small text-blue-400 hover:underline cursor-pointer"
                      >
                        Use current location
                      </div>
                    </div>
                  </div>
                  {(jsondata?.regionList?.length > 0 ||
                    jsondata?.cityList?.length > 0) && (
                    <div className="flex flex-col gap-[4px] ">
                      <div className="text-para-lg font-semibold">Region</div>
                      <div className="x-small font-semibold text-black uppercase">
                        Choose one or more
                      </div>
                      <ul
                        className={`pt-[12px] ${selectedLocation === "city" ? "opacity-50 cursor-not-allowed" : ""}`}
                      >
                        <li>
                          {FirstLevelRegion?.map(
                            (regionItem: any, index: number) => (
                              <Regions
                                key={index + 1}
                                item={regionItem}
                                regionListData={jsondata?.regionList}
                                formUrl={formUrl}
                                appendSearchParams={appendSearchParams}
                              />
                            ),
                          )}
                        </li>
                      </ul>
                    </div>
                  )}
                  {jsondata?.cityList && (
                    <div className="flex flex-col gap-[4px]">
                      <div className="text-para-lg font-semibold">City</div>
                      <div className="x-small font-semibold text-black uppercase">
                        Choose one or more
                      </div>
                      <div
                        className={`grid grid-cols-1 gap-[12px] sm:grid-cols-2 ${selectedLocation === "region" ? "opacity-50 cursor-not-allowed" : ""}`}
                      >
                        {jsondata?.cityList?.map(
                          (cityItem: any, index: number) => (
                            <CityCheckBoxComponent
                              key={index}
                              cityItem={cityItem}
                              formUrl={formUrl}
                              keyName={keyName}
                              appendSearchParams={appendSearchParams}
                            />
                          ),
                        )}
                      </div>
                    </div>
                  )}
                  {jsondata?.uniLocationTypeList && (
                    <div className="flex flex-col gap-[4px]">
                      <div className="text-para-lg font-semibold">
                        Location type
                      </div>
                      <div className="x-small font-semibold text-black uppercase">
                        Choose one
                      </div>
                      <div className="flex items-center gap-[8px]">
                        {jsondata?.uniLocationTypeList?.map(
                          (uniLocationTypeItem: any, index: number) => (
                            <div
                              className="form-black flex relative"
                              key={index}
                            >
                              {/* <Link
                                className="hidden"
                                id={
                                  sanitizeInput(keyName?.locationType) +
                                  sanitizeInput(
                                    uniLocationTypeItem?.locTypeTextKey
                                  )
                                }
                                href={{
                                  pathname: generatePathName(
                                    slug,
                                    keyName?.locationType
                                  ),
                                  query: formUrl(
                                    keyName?.locationType,
                                    sanitizeInput(
                                      uniLocationTypeItem?.locTypeTextKey
                                    )
                                  ),
                                }}
                              >
                                {uniLocationTypeItem?.locTypeDesc}
                              </Link> */}
                              <input
                                type="checkbox"
                                checked={
                                  prepopulateFilter?.locationType ==
                                  uniLocationTypeItem?.locTypeTextKey
                                }
                                onChange={() => {
                                  appendSearchParams(
                                    keyName?.locationType,
                                    sanitizeInput(
                                      uniLocationTypeItem?.locTypeTextKey,
                                    ),
                                  );
                                  setPrepopulateFilter((prev: any) => {
                                    const isSelected =
                                      prev?.locationType ===
                                      uniLocationTypeItem?.locTypeTextKey;
                                    return {
                                      ...prev,
                                      locationType: isSelected
                                        ? ""
                                        : uniLocationTypeItem?.locTypeTextKey,
                                    };
                                  });
                                }}
                                name={uniLocationTypeItem?.locTypeDesc}
                                className="rounded-[4px] outline-none absolute opacity-0"
                                id={uniLocationTypeItem?.locTypeDesc}
                                value={uniLocationTypeItem?.locTypeDesc}
                              />
                              <label
                                htmlFor={uniLocationTypeItem?.locTypeDesc}
                                className="btn btn-black-outline"
                              >
                                {uniLocationTypeItem?.locTypeDesc}
                              </label>
                            </div>
                          ),
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </Accordion>
            )}
        </>
      )}
    </>
  );
};

export default LocationFilterAccordian;
